const services = {
  title: "Offre de services",
  header: {
    overline: "TARIFS & ENGAGEMENT",
    titlePrefix: "Solutions sur mesure pour des produits",
    titleHighlight: "à fort impact",
    titleSuffix: "",
    subtitle:
      "Des modèles tarifaires transparents, pensés pour s’adapter à vos besoins : de la stratégie initiale à la mise en production.",
  },
  pricing: {
    mostPopular: "Le plus demandé",
    packs: {
      advisory: {
        title: "Advisory",
        subtitle: "Cadrage & stratégie",
        price: "2 000 €",
        period: "/ projet",
        description: "Idéal pour valider une idée et concevoir une roadmap technique.",
        features: ["Audit & stratégie data", "Conception d’architecture", "Choix de stack", "Roadmap performance"],
        cta: "Réserver un échange stratégique",
      },
      build: {
        title: "Build",
        subtitle: "Implémentation & IA",
        price: "550 €",
        period: "/ jour",
        description: "Développement de bout en bout de fonctionnalités IA.",
        features: ["Implémentation ML", "Développement d’API", "Pipelines data (ETL)", "Architecture backend"],
        cta: "Démarrer la réalisation",
      },
      scale: {
        title: "Scale",
        subtitle: "Croissance & maintenance",
        price: "6 000 €",
        period: "/ mois",
        description: "Support continu pour des systèmes haute performance.",
        features: ["Monitoring & support", "Fine-tuning de modèles", "Mise à l’échelle infra", "Itérations produit"],
        cta: "Parlons du scale",
      },
    },
  },
  productBased: {
    title: "Offres au forfait",
    subtitle: "Des engagements cadrés pour des jalons précis et du prototypage rapide.",
    poc: {
      title: "POC Data Science",
      description:
        "3–4 semaines pour valider le potentiel de vos données : prototypage modèle, analyse de faisabilité, et roadmap d’implémentation.",
      price: "7 500 €",
      priceLabel: "Forfait",
    },
    mvp: {
      title: "MVP SaaS Data",
      description:
        "Développement complet d’un produit fonctionnel avec des features IA : de l’UI/UX au déploiement cloud scalable en 8–12 semaines.",
      price: "15 000 €+",
      priceLabel: "À partir de",
    },
  },
  footerCta: {
    titlePrefix: "Prêt à accélérer votre",
    titleHighlight: "roadmap IA ?",
    subtitle:
      "Validation rapide ou implémentation SaaS complète : je vous aide à transformer des données complexes en avantages compétitifs.",
    button: "Planifier un appel de cadrage",
  },
  caseStudies: {
    overline: "Succès prouvés",
    titlePrefix: "Impact",
    titleHighlight: "concret",
    subtitle:
      "Du POC au SaaS prêt marché : découvrez comment j’aide mes clients à transformer la data en croissance.",
    resultLabel: "Résultat",
    viewCase: "Voir le cas",
  },
};

export default services;
